<template>
  <div class="archives-details-container" v-if="detail">
    <div class="archives-detail-header">
      <div class="avatar">
        <img v-if="detail.base.sex === '1'" :src="`/assets/img/archives/nan_tx.png`" class="avatar" />
        <img v-else-if="detail.base.sex === '2'" :src="`/assets/img/archives/nv_tx.png`" class="avatar" />
        <img v-else :src="`/assets/img/archives/default-avatar.png`" class="avatar" />
      </div>
      <div class="mobile">{{ detail.base.mobile }}</div>
      <div class="sex">
        <span v-if="detail.base.sex === '1'">男</span>
        <span v-else-if="detail.base.sex === '2'">女</span>
        <span v-else>未知</span>
      </div>
      <div class="gap">丨</div>
      <div class="birth">{{ detail.base.birth }}</div>
    </div>
    <div class="archives-detail-content">
      <div class="body-info">
        <div class="body-info-header">
          <div>90岁长寿概率：<span>{{ detail.m01.lift_rates_90 }}%</span></div>
        </div>
        <div class="body-info-content">
          <div>
            <div>身高:</div>
            <div>
              <p><span>{{ detail.base.height }}</span>cm</p>
            </div>
          </div>
          <div>
            <div>腰围:</div>
            <div>
              <p><span>{{ detail.base.waist }}</span>cm</p>
            </div>
          </div>
          <div>
            <div>体重:</div>
            <div>
              <p><span>{{ detail.base.weight }}</span>kg</p>
            </div>
          </div>
          <div>
            <div>臀围:</div>
            <div>
              <p><span>{{ detail.base.hip }}</span>cm</p>
            </div>
          </div>
        </div>
        <div class="body-info-action action" @click="handleViewBody">
          <p>查看AI体型档案</p>
          <img src="/assets/img/archives/more_icon.png" alt="">
        </div>
      </div>
      <div class="body-content">
        <div class="disease-info card">
          <div class="card-title">主要疾病风险</div>
          <div class="card-action " @click="handleViewDisease">
            <p>查看AI疾病档案</p>
            <img src="/assets/img/archives/more_icon.png" alt="">
          </div>
          <div class="card-content ">
            <div class="ai-disease">
              <div v-for="dis in detail.main_devg.dis || []" :key="dis" class="ai-disease-item">
                <img src="/assets/img/archives/hd_icon.png" class="ai-disease-item-icon" />
                <div class="ai-disease-item-name">
                  {{ dis }}
                </div>
              </div>
            </div>
            <div v-if="detail.main_devg.has_cancer_risk === 1" class="ai-disease-tip" hover-class="none"
              :hover-stop-propagation="false">
              <img :src="`/assets/img/archives/jingshi_icon.png`" class="ai-disease-tip-icon" />
              <p class="ai-disease-tip-text" :selectable="false" :decode="false">
                请注意，存在癌症风险
              </p>
            </div>
          </div>
        </div>
        <div class="fb-info card">
          <div class="card-title">骨健康情况</div>
          <div class="card-action" :class="{
            disabled: hideFb
          }" @click="handleViewFb">
            <p>查看AI骨健康档案</p>
            <img src="/assets/img/archives/more_icon.png" alt="">
          </div>

          <div class="card-content ">
            <div class="ai-bone">
              <div class="ai-bone-image" hover-class="none" :hover-stop-propagation="false">
                <img v-if="gzStatus === 1" :src="`/assets/img/archives/gmd_pic3.png`" class="ai-bone-image-item" />
                <img v-else-if="gzStatus === 2" :src="`/assets/img/archives/gmd_pic4.png`" class="ai-bone-image-item" />
                <img v-else :src="`/assets/img/archives/gmd_pic2.png`" class="ai-bone-image-item" />
              </div>
              <div class="ai-bone-content" hover-class="none" :hover-stop-propagation="false">
                <div class="ai-bone-content-title" hover-class="none" :hover-stop-propagation="false">
                  <p v-if="gzStatus === 0">
                    骨质健康
                  </p>
                  <p v-else-if="gzStatus === 1">
                    骨质不足
                  </p>
                  <p v-else-if="gzStatus === 2">
                    骨质疏松
                  </p>
                  <p v-else>不适用</p>
                </div>
                <div v-if="!hideFb" class="ai-bone-content-detail" hover-class="none" :hover-stop-propagation="false">
                  骨折风险最高的部位：{{ siteList[maxSite] || "--" }}
                </div>
                <div v-else class="ai-bone-content-detail" hover-class="none" :hover-stop-propagation="false">
                  * 骨健康风险仅适用于40-80岁人群
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="health-info card">
          <div class="card-title">营养保健方面</div>
          <div class="card-action" @click="handleViewHealth">
            <p>查看详细方案</p>
            <img src="/assets/img/archives/more_icon.png" alt="">
          </div>
          <div class="card-content ">
            <div class="ai-health">
              <div class="ai-health-info" hover-class="none" :hover-stop-propagation="false">
                基于您的疾病风险、骨健康状况，我们向您推荐以下营养保健品：
              </div>
              <div class="ai-health-table" hover-class="none" :hover-stop-propagation="false">
                <div v-for="(item, index) in detail.health_products" :key="item">
                  <div class="ai-health-table-item" hover-class="none" :hover-stop-propagation="false">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { getReportDetail } from '@/utils/axios';



/**
 * 是否隐藏骨健康
 * 条件  大于80小于等于90 或者 小于40大于等于20
 */
function isHideFb (age) {
  console.log('age', age)
  if ((age <= 90 && age > 80) || (age < 40 && age >= 20)) {
    return true
  } else {
    return false
  }
}



export default {
  name: 'llkjBackIndex',

  data () {
    return {
      detail: null,
      siteList: {
        site1: '头部',
        site2: '颈椎部',
        site3: '上肢',
        site4: '下肢',
      },
      maxSite: "site1",
      hideFb: false,
    };
  },

  mounted () {
    const id = this.$route.query.id;
    console.log("detail page id: ", id);
    if (id) {
      this.getDetail(id);
    }
  },

  computed: {
    gzStatus () {
      const tscore = this.detail.base.tscore

      if (tscore === undefined || tscore === '') {
        return -1
      }
      else if (Number(tscore) > -1) {
        return 0
      }
      else if (Number(tscore) <= -2.5) {
        return 2
      }
      else {
        return 1
      }
    }
  },

  methods: {
    getDetail (id) {
      getReportDetail({ id }).then(res => {
        if (res.code === 200) {
          const data = JSON.parse(window.atob(res.data));
          console.log(data);
          this.detail = data;
          this.hideFb = isHideFb(Number(data.base.age))
          this.maxSite = this.getMaxSite(this.detail.fb_detail.site)
        } else {
          console.log(res.msg);
        }
      })
    },
    getMaxSite (data) {
      if (!data)
        return ''
      const dataArr = Object.entries(data)
      let maxSite = ''
      let maxNum = 0
      dataArr.forEach((item) => {
        if (Number(item[1]) > maxNum) {
          maxSite = item[0]
          maxNum = Number(item[1])
        }
      })
      return maxSite
    },
    // 新建页签打开
    openNewTab (name) {
      const openUrl = this.$router.resolve({
        name,
        query: {
          id: this.$route.query.id
        }
      })
      window.open(openUrl.href)
    },
    handleViewBody () {
      this.openNewTab('archivesDetailBody')
    },
    handleViewDisease () {
      this.openNewTab('archivesDetailDisease')
    },
    handleViewHealth () {
      this.openNewTab('archivesDetailHealth')
    },
    handleViewFb () {
      if (this.hideFb) {
        return
      }
      console.log('handleViewFb')
      this.openNewTab('archivesDetailFb')
    },
  },
};
</script>


<style>
html,
body {
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}
</style>


<style lang="scss" scoped>
.archives-details-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  gap: 20px;
  padding: 10px;
  background-color: #fff;

  >div {
    position: relative;
    width: 100%;
    min-height: 100%;
    border-radius: 12px;
  }

  .archives-detail-header {
    padding: 20px;
    background-color: #F2F4FA;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    .avatar {
      position: relative;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .mobile {
      font-weight: bold;
      font-size: 18px;
    }
  }

  .archives-detail-content {
    background-image: url("/assets/img/archives/main_bg.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 40% 1fr;
    grid-template-areas: "body body body" "content content content";
    grid-gap: 20px;
    padding: 20px;
    overflow: hidden;

    >div {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 5px;
      text-align: center;
      font-size: 16px;
      line-height: 1.5;
      color: #333;
    }

    .body-info {
      padding: 20px;
      grid-area: body;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 20px;

      &-header {
        position: relative;
        width: fit-content;
        padding: 18px 32px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #282A2C;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0px 2px 0px 0px #FFFFFF;
        border-radius: 31px 31px 31px 31px;

        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #2C50F2;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      &-content {
        position: relative;
        width: 30%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: repeat(2, 1fr);
        gap: 40px;

        >div {
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 16px;
          color: #282A2C;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          &:nth-child(2n) {
            text-align: right;
          }

          p {
            font-size: 20px;
          }
        }
      }

      &-action {
        position: absolute;
        top: 20px;
        right: 20px;
        background: linear-gradient(94deg, #4066EE 0%, #55A7FF 100%), #D9D9D9;
        font-size: 16px;

      }
    }

    .body-content {
      grid-area: content;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .card {
      height: 100%;
      width: 30%;
      background-image: url("/assets/img/archives/case_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 16% 1fr;
      grid-template-areas: "title action" "content content";
      overflow: hidden;
      margin-right: 3%;

      .disabled {
        opacity: 0.5;
        cursor: default !important;
      }

      &:last-child {
        margin-right: 0;
      }

      >div {
        position: relative;
        width: 100%;
        height: 100%;
      }

      &-title {
        grid-area: title;
        display: flex;
        align-items: center;
        font-family: SF Pro Text, SF Pro Text;
        font-weight: 600;
        font-size: 24px;
        color: #282A2C;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding: 0 30px;
      }

      &-action {
        grid-area: action;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
        text-transform: none;
        font-size: 24px;
        user-select: none;
        cursor: pointer;

        >img {
          width: 32px;
          height: 32px;
        }
      }

      &-content {
        grid-area: content;
        padding: 20px;


        .ai-disease {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          gap: 10px;

          &-item {
            position: relative;
            width: fit-content;
            height: fit-content;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
            font-size: 14px;
            font-weight: bold;
            border-radius: 5px;
            background-color: #eef2f5;
            padding: 10px;
            white-space: nowrap;

            &-icon {
              width: 12px;
              height: 12px;
              margin-right: 16px;
            }
          }
        }

        .ai-disease-tip {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 20px 0;
          font-weight: bold;
          font-size: 16px;
          color: #ff3f3f;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          &-icon {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }


        .ai-bone {
          display: grid;
          grid-template-columns: 224px 1fr;
          grid-template-rows: 224px;
          gap: 10px;

          >view {
            position: relative;
            width: 100%;
            height: 100%;
          }

          &-image {
            &-item {
              width: 100%;
              height: 100%;
            }
          }

          &-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            &-title {
              font-weight: bold;
              font-size: 20px;
              color: #2c50f2;
              line-height: 32px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin-bottom: 10px;
            }

            &-detail {
              font-weight: bold;
              font-size: 18px;
              color: #282a2c;
              line-height: 28px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        .ai-health {
          &-info {
            font-weight: bold;
            font-size: 18px;
            color: #282a2c;
            line-height: 44px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 20px;
          }

          &-table {
            position: relative;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);

            >div {
              position: relative;
              width: 100%;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #000;
              font-size: 16px;
              font-weight: bold;
              border: 2px solid #e7e7e7;

              &:nth-child(1) {
                border-top-left-radius: 10px;
              }

              &:nth-child(2) {
                border-top-right-radius: 10px;
              }

              &:nth-last-child(1) {
                border-bottom-right-radius: 10px;
              }

              &:nth-last-child(2) {
                border-bottom-left-radius: 10px;
              }

              &:nth-child(4n-2),
              &:nth-child(4n-3) {
                background-color: #f5f5f5;
              }
            }
          }
        }

      }



    }

    .disease-info {
      grid-area: disease;
    }

    .fb-info {
      grid-area: fb;
    }

    .health-info {
      grid-area: health;
    }
  }

  .action {
    border-radius: 20px 20px 20px 20px;
    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 20px;

    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>